__turbopack_context__.v({
  "text": "Timer-module__AdkGQa__text",
});
